export default {
    organisationBaseData: 'Daten'
}
